var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      ref: "PowerbarNav",
      staticClass: "powerbar-nav ax-utilities",
      attrs: { id: "powerbar-nav" }
    },
    [
      _c(
        "div",
        { staticClass: "powerbar-nav__info-container" },
        [
          _c(
            "IconButton",
            {
              attrs: { title: "Home", href: _vm.homeIconUrl, id: "home-icon" }
            },
            [_c("home-icon")],
            1
          ),
          _vm._v(" "),
          !_vm.scopeIsHome
            ? _c("IconChip", { attrs: { entityChipData: _vm.entityChipData } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "powerbarNavContainer",
          staticClass: "powerbar-nav__links-container"
        },
        [
          _c(
            "nav",
            {
              staticClass: "powerbar-nav__nav",
              attrs: {
                id: "primary-nav-menu",
                role: "navigation",
                "aria-label": "primary-nav-menu"
              }
            },
            _vm._l(_vm.menus, function(menu, index) {
              return _c("top-level-menu-item", {
                key: menu.caption,
                attrs: {
                  id: menu.caption + "-menu",
                  caption: menu.caption,
                  items: menu.menuItems,
                  itemIndex: index
                },
                on: { navigate: _vm.navigate }
              })
            }),
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.scopeIsFund
        ? _c(
            "div",
            { staticClass: "powerbar-nav__shortcuts-container" },
            [_c("shortcuts-bar", { attrs: { baseUrl: _vm.baseUrl } })],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }